<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Expenses Details

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">

               

                <div class="row margin-bottom-3px">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="diaplayName" class="margin-bottom-0px">Item</label>
                      </div>

                      <div class="col-md-5">
                        <CustomDataByRequestType RequestedType="ExpenseTypes" ActorCode={{ActorCode}}
                                                 (keyChange)="Roleassign($event)"
                                                 [(ngModel)]="SelectedItemCode" name="SelectedFacilityCode"
                                                 required>
                        </CustomDataByRequestType>
                        <!--<CodeTypeValue CodeType="RELTP"
             id="itemname" (ngModelChange)="onChange2($event)"
  [(ngModel)]="itemName" SelectedValue=""
  name="itemname"            >
         </CodeTypeValue>-->
                        <!--<CodeTypeValue CodeType="RELTP"
                 id="CurrentActorAddEmergencyInfoRequest.RelationType"
                 [(ngModel)]="CurrentActorAddEmergencyInfoRequest.RelationType" SelectedValue=""
                 name="CurrentActorAddEmergencyInfoRequest.RelationType">
  </CodeTypeValue>-->
                        <!--<input type="text" class="form-control" placeholder="Relation Name" />-->
                        <!--id="CurrentActorEditEmergencyInfoRequest.RelationType"
         [(ngModel)]="CurrentActorEditEmergencyInfoRequest.RelationType"
         name="CurrentActorEditEmergencyInfoRequest.RelationType"
          maxlength="20" minlength="1" #RelationType="ngModel" pattern="^[\sa-zA-Z0-9,/._\-?]*$">
  <small class="form-text text-danger"
         *ngIf="(!RelationType.valid && (RelationType.dirty || RelationType.touched) && RelationType.errors.required)">(Field cannot be left blank)</small>
  <small class="form-text text-danger"
         *ngIf="(!RelationType.valid && RelationType.errors.pattern)">(special characters are not allowed)</small>-->

                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="firstName"> Description</label>
                      </div>
                      <div class="col-md-4">

                        <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Description"
                                  name="Description"
                                  [(ngModel)]="description" required minlength="1" maxlength="100"
                                  #addconcerns_text="ngModel"></textarea>
                        <small class="form-text text-danger"
                               *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>
                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row margin-bottom-3px">
                      <div class="col-md-3 text-align-right padding-left-0px">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-5px"> Item Amount </label>
                      </div>
                      <div class="col-md-5">
                        <!--<input type="text" class="form-control" placeholder="Item Amount"
        >-->
                        <input type="text" class="form-control" placeholder="Item Amount"
         id="itemamount"
         [(ngModel)]="ItemAmount"
         name="Itemamount" #Endometrium="ngModel"
         maxlength="5" pattern="^[\0-9,._\-?]*$" required>
  <small class="form-text text-danger"
         *ngIf="(!Endometrium.valid && (Endometrium.dirty || Endometrium.touched) && Endometrium.errors.required )">(Field cannot be left blank)</small>
  <small class="form-text text-danger"
         *ngIf="(!Endometrium.valid && Endometrium.errors.pattern)">(only numbers are allowed)</small>


                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="firstName"> Remarks</label>
                      </div>
                      <div class="col-md-4">

                        <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                                  name="remarks"
                                  [(ngModel)]="Remarks" required minlength="1" maxlength="100"
                                  #addconcerns_text1="ngModel"></textarea>
                        <small class="form-text text-danger"
                               *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))">(Required)</small>

                      </div>

                    </div>

                  </div>
                </div>

              


              </div>
            </div>


         

















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" class="btn actions-btn-prime float-right font-size-13px" (click)="Data()">OK</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
